// src/pages/RideDetails.js
import React from 'react';

export default function RideDetails({ ride }) {
  // Demo ride data if no ride prop is passed in
  const demoRide = {
    id: 1,
    date: '2025-02-15T10:30:00',
    car: 'Tesla Model S',
    location: 'Lot 112',
    parkedBy: 'Jerry Jack',
    retrievedBy: 'Anna Brave',
    paid: '$15',
    duration: '2h 45m',
  };

  const currentRide = ride || demoRide;
  const formattedDate = new Date(currentRide.date).toLocaleString();

  return (
    <div style={{ padding: '20px' }}>
      <h2 style={{ color: '#ba00ba', marginBottom: '20px' }}>Ride Details</h2>
      <div style={{
        background: '#fff',
        borderRadius: '8px',
        padding: '20px',
        boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
      }}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <tbody>
            <tr style={{ borderBottom: '1px solid #eee' }}>
              <td style={{ padding: '8px', fontWeight: 'bold' }}>Ride ID</td>
              <td style={{ padding: '8px' }}>{currentRide.id}</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #eee' }}>
              <td style={{ padding: '8px', fontWeight: 'bold' }}>Date</td>
              <td style={{ padding: '8px' }}>{formattedDate}</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #eee' }}>
              <td style={{ padding: '8px', fontWeight: 'bold' }}>Car</td>
              <td style={{ padding: '8px' }}>{currentRide.car}</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #eee' }}>
              <td style={{ padding: '8px', fontWeight: 'bold' }}>Location</td>
              <td style={{ padding: '8px' }}>{currentRide.location}</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #eee' }}>
              <td style={{ padding: '8px', fontWeight: 'bold' }}>Parked By</td>
              <td style={{ padding: '8px' }}>{currentRide.parkedBy}</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #eee' }}>
              <td style={{ padding: '8px', fontWeight: 'bold' }}>Retrieved By</td>
              <td style={{ padding: '8px' }}>{currentRide.retrievedBy}</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #eee' }}>
              <td style={{ padding: '8px', fontWeight: 'bold' }}>Payment</td>
              <td style={{ padding: '8px' }}>{currentRide.paid}</td>
            </tr>
            <tr>
              <td style={{ padding: '8px', fontWeight: 'bold' }}>Duration</td>
              <td style={{ padding: '8px' }}>{currentRide.duration}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}
